import extractRawElm from './extract-raw-elm'

export function onEventPassive($elm, event, handler) {
  const elm = $elm === window ? $elm : extractRawElm($elm)
  elm.addEventListener(event, handler, { passive: true })
  return $elm
}

export function onEvent($elm, event, handler) {
  const elm = $elm === window ? $elm : extractRawElm($elm)
  elm.addEventListener(event, handler)
  return $elm
}

export function offEvent($elm, event, handler) {
  const elm = $elm === window ? $elm : extractRawElm($elm)
  elm.removeEventListener(event, handler)
  return $elm
}
